import React from 'react'

function TextError(props) {
    return <div className='input-feedback d-flex justify-content-end'>
        {props.children}
    </div>
}

export default TextError
